import React from 'react';
import {Typography} from '@mui/material';

export const LabelText = React.memo(({children}: React.PropsWithChildren<{}>) => (
   <Typography variant="body2">{children}</Typography>
));
